export default __webpack_public_path__ + "static/media/2017 LV BOOTH EXPLANATION-02.c0d82924.jpg";